// extracted by mini-css-extract-plugin
export default {"button-wrapper":"GIlR4N","buttonWrapper":"GIlR4N","full-width-button":"mxFx9p","fullWidthButton":"mxFx9p"};